import { getToken } from '@/utils/tokenUtils';

/** The pair the payment gateway sends a super top-up payment back to (backend B15). */
const STU_RETURN_PATHS = ['/retail/super-top-up/success', '/retail/super-top-up/failure'];

/**
 * True when the current URL is a super top-up payment return reached without a session: the
 * gateway sends the browser back carrying `quoteId` and `planId`, and the page shows its own
 * fallback rather than a forced logout.
 *
 * Used by the app context alongside the retail check, to suppress global auth redirects and
 * authenticated queries before the page can render.
 */
export function isUnauthenticatedStuPaymentReturn(): boolean {
  if (getToken()) return false;

  if (!STU_RETURN_PATHS.includes(window.location.pathname)) return false;

  const searchParams = new URLSearchParams(window.location.search);
  return !!searchParams.get('quoteId') && !!searchParams.get('planId');
}
